define('plugin/package/view/PackageInvoiceInstanceItemView',['require','plugin/package/view/PackageClientInstanceItemView','lib/model/package/PackageDataInflator'],function (require) {

    var Parent = require('plugin/package/view/PackageClientInstanceItemView');
    var Inflator = require('lib/model/package/PackageDataInflator');

    /**
     * Package invoice instance info view
     *
     * @class PackageInvoiceInstanceItemView
     */
    return Parent.extend({

        getTemplate: function () {
            return '#package_invoice_instance_item_view';
        },
        ui: {
            'checkbox': '.sb-package-checkbox',
            'collapse': '.sb-collapse'
        },
        events: {
            'change @ui.checkbox': '_onChangeCheckbox'
        },
        _readonly: false,
        _isOpened: false,

        initialize: function () {
            Parent.prototype.initialize.apply(this);

            this._isOpened = this.getOption('isOpened');
        },

        onRender: function () {
            this.ui.collapse.on('hide.bs.collapse', _.bind(function () {
                this._isOpened = false;
                this.triggerMethod('hide:package:instance');
            }, this));
            this.ui.collapse.on('show.bs.collapse', _.bind(function () {
                this._isOpened = true;
                this.triggerMethod('show:package:instance');
            }, this));
        },

        setReadonly: function (flag) {
            this._readonly = flag;
            if (!this.isDestroyed) {
                this.render();
            }
        },

        serializeData: function () {
            var usedModel = this.getOption('invoiceModel').get('package_instances').get(this.model.id);

            return _.extend(Parent.prototype.serializeData.apply(this), {
                used: !!usedModel,
                viewonly: !this.getOption('allowToEdit'),
                readonly: this._readonly || !this.getOption('allowToEdit') || !this._canUse(),
                is_opened: this._isOpened
            });
        },

        _onChangeCheckbox: function () {
            if (this.ui.checkbox.is(':checked')) {
                this.triggerMethod('use:package:instance');
            } else {
                this.triggerMethod('delete:package:instance');
            }
        },

        _canUse: function () {
            return new Inflator().canUseInstanceInInvoice(this.model, this.getOption('invoiceModel'));
        },

        _attachInfo: function (data) {
            data = Parent.prototype._attachInfo.apply(this, arguments);

            return new Inflator().attachUsedQtyToInstance(data, this.getOption('invoiceModel').get('package_instances'));
        }

    });

});
